<template>
  <transition name="el-zoom-in-top">
    <el-dialog :close-on-click-modal="false" title="编辑质检报告" :visible.sync="report.show" width="50%">
      <div style="text-align: left;" v-show="report.show">
        <div slot="header" class="clearfix"></div>
        <div v-show="show">
          <!-- 填写基础信息 -->
          <el-form ref="report" :model="report" label-width="120px" :rules="rules">

            <el-form-item label="上传图片">
              <el-upload accept=".pdf,.png,.jpg" ref="upload" :data="uploaddata" :action="uploadurl" :headers="headers"
                list-type="picture-card" :http-request="UploadImage" :on-success="qinchulist"
                :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :before-upload="beforeAvatarUpload"
                :auto-upload="true" :file-list="fileList" :limit="1" name="formFile">
                <el-tooltip class="item" effect="dark" content="只能上传一张图片" placement="top">
                  <i class="el-icon-plus"></i>
                </el-tooltip>
              </el-upload>
            </el-form-item>

            <el-form-item>
              <el-row>
                <el-col :span="24">
                  <el-input @change="inputChange" style="width: 80%;" v-model="report.quality_field1"
                    placeholder="请输入内容" />
                </el-col>
                <el-col :span="24">
                  <el-image v-if="!isPdf" width="300px" v-show="report.quality_field1.length"
                    :preview-src-list="[report.quality_field1]" :src="report.quality_field1" alt="图片展开"
                    style="height: 100px;width:auto" />
                </el-col>
                <el-col :span="24">
                  <div v-if="isPdf" class="interviewVideo_main" style="height: 500px;width:600px" id="videoContainer">
                    <!--此处根据pdf的页数动态生成相应数量的canvas画布-->
                    <canvas v-for="pageIndex in pdfPages" :id="`pdf-canvas-` + pageIndex" :key="pageIndex"
                      style="display: block"></canvas>
                  </div>
                </el-col>
              </el-row>
            </el-form-item>
            <!-- <el-form-item label="质检图片2">
              <el-input v-model="report.quality_field2" placeholder="请输入内容"></el-input>
              <el-image width="300px" v-show="report.quality_field2.length" :preview-src-list="[report.quality_field2]"
                :src="report.quality_field2" alt="图片展开" style="height: 100px;width:auto" />
            </el-form-item>
            <el-form-item label="质检图片3">
              <el-input v-model="report.quality_field3" placeholder="请输入内容"></el-input>
              <el-image width="300px" v-show="report.quality_field3.length" :preview-src-list="[report.quality_field3]"
                :src="report.quality_field2" alt="图片展开" style="height: 100px;width:auto" />
            </el-form-item> -->
          </el-form>
          <div style="text-align: center;">
            <el-button style="margin-top: 12px;" @click="submitadd('report')" type="primary">提交</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </transition>
</template>


<script>
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import workerSrc from "pdfjs-dist/build/pdf.worker.min";
import {
  qualityreportsupdate,
} from "@/api/plant";
import {
  productupLoad2,
} from "@/api/base";
import { getToken } from '@/utils/auth'
export default {
  props: {
    search: {
      type: Function,
      default: null
    },
  },
  data() {
    return {
      // uploadurl: process.env.VUE_APP_BASE_API + "/api/out/minio/upload",
      uploadurl:
        process.env.VUE_APP_BASE_API + "/api/baseinfo/product/upLoad",
      uploaddata: {
        bucketType: 1,
      },
      isPdf: null,
      //基础数据
      show: true,
      // 上传图片
      report: {
        show: false,
        id: null,
        quality_field1: '',
        // quality_field2: '',
        // quality_field3: '',
      },
      headers: {
        Token: getToken()
      },
      fileList: [],
      dialogVisible: false,
      rules: {},
      pdfDoc: {}, // 保存加载的pdf文件流
      pdfPages: 0, // pdf文件的页数
      //pdf文件的链接
      pdfUrl: "",
      pdfScale: 1.0,
    };
  },
  mounted() { },
  methods: {
    getData(val = null) {
      console.log(val, 'val');
      this.fileList = []
      this.isPdf = this.checkIfPDF(val || this.report.quality_field1)

      if (this.isPdf) this.getPdf()
    },
    getPdf() {
      setTimeout(() => {
        this.$refs.upload.clearFiles();
      }, 300)
      pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;
      const loadingTask = pdfjsLib.getDocument({
        url: this.report.quality_field1,
        withCredentials: false,
        cMapPacked: true,
        cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.2.228/cmaps/',
        cMapPacked: true,
      });
      loadingTask.promise.then((pdf) => {
        this.pdfDoc = pdf;                 //获取pdf文档流
        this.pdfPages = pdf.numPages;//获取pdf文件的页数
        this.$nextTick(() => {
          this.renderPage(1);
        });
      }).catch(err => {
        console.log(err, '上传err');
      })
    },
    renderPage(num) {
      this.pdfDoc.getPage(num).then((page) => {
        const canvasId = "pdf-canvas-" + num;
        const canvas = document.getElementById(canvasId);
        const ctx = canvas.getContext("2d");

        let viewport = page.getViewport({ scale: this.pdfScale });
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        const renderContext = {
          canvasContext: ctx,
          viewport: viewport,
        };
        page.render(renderContext);
        // 显示整个pdf
        if (num < this.pdfPages) {
          this.renderPage(num + 1);
        }
      });
    },
    UploadImage(request) {
      const { action, data, filename } = request;
      // 新建formDate对象
      let formData = new FormData();
      // 文件单独push,第三个参数指定上传的文件名
      let files = new window.File([request.file], request.file.name);
      formData.append(filename, files, request.file.name);

      productupLoad2(formData)
        .then(res => {
          this.isPdf = this.checkIfPDF(res.data)
          console.log(this.isPdf, 'pddd');
          this.report.quality_field1 = decodeURIComponent(res.data)
          if (this.isPdf) {
            this.getPdf()
          }
        })
        .catch(response => {
          console.log(response, "图片上传失败");
        });
    },
    //保存提交
    submitadd(formName) {
      this.$refs[formName].validate(valid => {
        //基础表单验证
        if (valid) {
          // 上传图片
          console.log(this.report, 'ppp');
          const params = this.report
          // this.isPdf ? params.quality_field1 = params.quality_PdfField : ''

          qualityreportsupdate(params).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "提交成功!"
              });
              this.report.show = false;
              this.resetForm("report");
              this.search();
              this.report.show = false;
            } else {
              this.$message({
                type: "warning",
                message: "修改失败!请检查字段"
              });
            }
          });
        }
      });
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    qinchulist(response, file, fileList) {
      console.log(response);
      // this.report.quality_field1 = response.data;
      this.$message({
        type: "success",
        message: "上传成功!"
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 1MB!');
      }
      return isLt2M;
    },
    handleRemove(file, fileList) {
      this.report.quality_reports = "";
    },
    handlePictureCardPreview(file) {
      // this.dialogImageUrl = file.url;
      this.report.show = true;
    },
    checkIfPDF(filename) {
      const lastDotIndex = filename.lastIndexOf('.');
      if (lastDotIndex === -1) {
        return false;
      }
      const extension = filename.substring(lastDotIndex + 1).toLowerCase();
      return extension === 'pdf';
    },
    inputChange(e) {
      this.getData(e)
    },
  }
};
</script>

<style></style>
